import React, { createContext, useContext, useRef, useState } from "react";

const GlobalLoadingContext = createContext();

export const GlobalLoadingProvider = ({ children }) => {
  const [isGlobalLoading, setIsGlobalLoading] = useState(false);

  const loadingStartTimeRef = useRef(null);
  const hideTimeoutRef = useRef(null);

  const startLoading = () => {
    // Clear any pending hide timeout
    if (hideTimeoutRef.current) {
      clearTimeout(hideTimeoutRef.current);
      hideTimeoutRef.current = null;
    }

    // If already visible, just update start time
    if (!isGlobalLoading) {
      setIsGlobalLoading(true);
    }
    loadingStartTimeRef.current = Date.now();
  };

  const stopLoading = () => {
    const minDuration = 1000; // 1 second minimum
    const now = Date.now();
    const startedAt = loadingStartTimeRef.current ?? now;
    const elapsed = now - startedAt;
    const remaining = Math.max(0, minDuration - elapsed);

    if (remaining === 0) {
      setIsGlobalLoading(false);
      loadingStartTimeRef.current = null;
    } else {
      // Wait remaining time, then hide
      hideTimeoutRef.current = setTimeout(() => {
        setIsGlobalLoading(false);
        loadingStartTimeRef.current = null;
        hideTimeoutRef.current = null;
      }, remaining);
    }
  };

  return (
    <GlobalLoadingContext.Provider
      value={{ isGlobalLoading, startLoading, stopLoading }}
    >
      {children}
    </GlobalLoadingContext.Provider>
  );
};

export const useGlobalLoading = () => useContext(GlobalLoadingContext);
